import { jsxs as l, jsx as c } from "react/jsx-runtime";
import { useI18n as N } from "next-localization";
import { u as t } from "./use-get-facility-status.Ks2aGXq5.js";
import { NeuTag as s } from "@hcahealthcaredpx/neutron-react";
const T = ({
  result: a,
  className: p,
  facilityTypeClass: r,
  erWaitClass: h,
  erFeed: o
}) => {
  var i, m;
  const { t: d } = N(), { operatingStatus: n, isTemporarilyClosed: e } = t(a);
  return /* @__PURE__ */ l("span", { className: p, children: [
    /* @__PURE__ */ l("span", { className: r, children: [
      (i = a == null ? void 0 : a.marketedSecondaryTypeNames) != null && i.length ? /* @__PURE__ */ c("span", { className: "pe-1", children: /* @__PURE__ */ c(s, { color: "gray", children: (m = a == null ? void 0 : a.marketedSecondaryTypeNames) == null ? void 0 : m[0] }) }) : null,
      n != null && n.text ? /* @__PURE__ */ c("span", { className: "pe-1", children: /* @__PURE__ */ c(s, { color: n == null ? void 0 : n.color, children: n.text }) }) : null
    ] }),
    !e && (o == null ? void 0 : o.description) && /* @__PURE__ */ l("span", { className: h, children: [
      /* @__PURE__ */ c("span", { className: "pe-1", children: /* @__PURE__ */ c(s, { icon: "schedule", color: "gray", className: "pe-1 d-inline-block", children: d("Locations.Card.AverageERWait") }) }),
      /* @__PURE__ */ c("span", { className: "pe-1", children: /* @__PURE__ */ c(s, { color: "blue", children: o == null ? void 0 : o.description }) })
    ] })
  ] });
};
export {
  T as S
};
